import { Link } from "react-router-dom";

export function Navbar() {
  return (
    <header className="w-full h-16 bg-white shadow-sm border-b flex items-center justify-between px-6">

      {/* Left Section - Search Input */}
      <div className="flex items-center gap-3 w-1/3">
        <input
          type="text"
          placeholder="Search anything..."
          className="w-full px-4 py-2 rounded-xl bg-gray-100 outline-none border border-transparent focus:border-blue-400"
        />
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-6">

        {/* Weather */}
        <div className="text-gray-600 font-medium">36°F</div>

        {/* Notifications */}
        <Link
          to="/notifications"
          className="relative text-gray-600 hover:text-gray-800"
        >
          <span className="text-2xl">🔔</span>
          <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full"></span>
        </Link>

        {/* Calendar */}
        <Link
          to="/calendar"
          className="text-gray-600 hover:text-gray-800 text-2xl"
        >
          📅
        </Link>

        {/* Profile */}
        <Link to="/profile">
          <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center cursor-pointer">
            <span className="font-semibold text-white">M</span>
          </div>
        </Link>

      </div>
    </header>
  );
}
